import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $convertFromMarkdownString } from '@lexical/markdown';
import { EDITOR_TRANSFORMER, getTransformedMarkdown } from '../../utils/utils';
import { $getRoot } from 'lexical';
type TextSyncPluginProps = {
  setForceUpdateRTEAnswer?: (prevValue: boolean) => void;
  text?: string;
};
const TextSyncPlugin = ({
  text,
  setForceUpdateRTEAnswer
}: TextSyncPluginProps) => {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    if (editor && text) {
      editor.update(() => {
        const root = $getRoot();
        root.clear();
        const transformedMarkdown = getTransformedMarkdown(text);
        $convertFromMarkdownString(transformedMarkdown, EDITOR_TRANSFORMER);

        // Place the cursor at the end
        const lastChild = root.getLastChild();
        if (lastChild) {
          lastChild.selectEnd();
        }
      });
      setForceUpdateRTEAnswer?.(false);
    }
  }, [text, editor, setForceUpdateRTEAnswer]);
  return null;
};
export default TextSyncPlugin;